// ================================================================
// Sprachregister — die EINZIGE Quelle für alle Sprachlisten der App.
// ================================================================
// Wer eine Sprachliste braucht, importiert sie HIER (Onboarding-Sprachwahl,
// WhatsApp-Übersetzungs-Sheet, Einstellungen, i18n-Registry) — keine
// Kopien mehr in einzelnen Komponenten.
//
// `name` = Endonym (Eigenname der Sprache) — bewusst FEST statt
// Intl.DisplayNames: nicht jeder Browser kennt jede Locale (Fallback wäre
// der englische Name, z.B. «Albanian» statt «Shqip»).
//
// `english` = englischer Name für Übersetzungs-Prompts (muss mit LANG_NAMES
// im Backend übereinstimmen: backend/src/modules/whatsapp/whatsapp-translate.service.ts —
// das Backend kann dieses Frontend-Modul nicht importieren).
//
// Eine NEUE Sprache aktivieren: (1) Eintrag hier, (2) <code>.json erzeugen
// (scripts/translate-i18n.mjs), (3) Import in i18n/index.js, (4) Backend
// LANG_NAMES ergänzen. `npm run build` prüft die Vollständigkeit der JSONs.
//
// Die Produktschnittstelle bleibt laut UI-Vertrag durchgehend LTR. Arabische
// und persische Inhalte werden übersetzt, ändern aber nicht die Layoutrichtung.
// Kurmancî (`ku`) verwendet hier ebenfalls lateinische Schrift.
//
// `document: false` = diese Sprache steht NICHT als Dokumentsprache zur Wahl
// (Offerte/Rechnung an den Kunden). Grund: die PDF-Vorlagen sind LTR gebaut
// (Tabellen, QR-Zahlteil, Briefbogen) — arabischer/persischer Text käme
// verstümmelt heraus. Die UI-Sprache bleibt davon unberührt.
// Die Liste MUSS zu backend/src/config/document-languages.ts passen; dort
// entscheidet sie, was tatsächlich gedruckt werden darf.
export const APP_LANGUAGES = [
  { code: 'de', flag: '🇩🇪', name: 'Deutsch', english: 'German' },
  { code: 'en', flag: '🇬🇧', name: 'English', english: 'English' },
  { code: 'fr', flag: '🇫🇷', name: 'Français', english: 'French' },
  { code: 'it', flag: '🇮🇹', name: 'Italiano', english: 'Italian' },
  { code: 'es', flag: '🇪🇸', name: 'Español', english: 'Spanish' },
  { code: 'pt', flag: '🇵🇹', name: 'Português', english: 'Portuguese' },
  { code: 'tr', flag: '🇹🇷', name: 'Türkçe', english: 'Turkish' },
  { code: 'sq', flag: '🇦🇱', name: 'Shqip', english: 'Albanian' },
  { code: 'sr', flag: '🇷🇸', name: 'Српски', english: 'Serbian' },
  { code: 'hr', flag: '🇭🇷', name: 'Hrvatski', english: 'Croatian' },
  { code: 'ar', flag: '🇸🇦', name: 'العربية', english: 'Arabic', document: false },
  { code: 'ru', flag: '🇷🇺', name: 'Русский', english: 'Russian' },
  { code: 'uk', flag: '🇺🇦', name: 'Українська', english: 'Ukrainian' },
  { code: 'pl', flag: '🇵🇱', name: 'Polski', english: 'Polish' },
  { code: 'nl', flag: '🇳🇱', name: 'Nederlands', english: 'Dutch' },
  { code: 'fa', flag: '🇮🇷', name: 'فارسی', english: 'Persian', document: false },
  // Kurdisch (Kurmancî, lateinische Schrift). Es gibt kein Flaggen-Emoji für
  // Kurdistan — die Sonne steht für die Roj im Zentrum der Flagge.
  { code: 'ku', flag: '☀️', name: 'Kurdî', english: 'Kurdish (Kurmanji)', document: false },
];

/**
 * Sprachen, in denen Dokumente für Kunden erzeugt werden dürfen.
 * Reihenfolge wie APP_LANGUAGES (Deutsch zuerst).
 */
export function getDocumentLanguages() {
  return APP_LANGUAGES.filter((l) => l.document !== false);
}

// Angekündigte, noch NICHT übersetzte Sprachen (Einstellungs-Sheet «Bald»).
// Sobald eine davon aktiviert wird, wandert sie nach APP_LANGUAGES hoch.
export const COMING_LANGUAGES = [
  { code: 'ro', flag: '🇷🇴', name: 'Română', english: 'Romanian' },
  { code: 'prs', flag: '🇦🇫', name: 'دری', english: 'Dari' },
  { code: 'ps', flag: '🇦🇫', name: 'پښتو', english: 'Pashto' },
];
